@if (false) {
  <div class="card">
    <p-chart [data]="data" [options]="options" type="bar" />
  </div>
} @else {
  <div class="card">Welcome</div>
}
